/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetPresenceResponseJson } from './get-presence-response-json';
import { GetPresenceResult } from '../results/get-presence-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { PresenceDto } from '../models/presence-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetPresenceResponse extends ResponseWithErrorGeneric<GetPresenceResponseJson, GetPresenceResult> implements IResponseWithErrorGeneric<GetPresenceResult> {
  public presence: PresenceDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetPresenceResponse>) {
    super(response, GetPresenceResult.Error);
    if (this.result !== GetPresenceResult.Success) {
      return;
    }

    this.presence = [];
    if (this.body.presence != null)
      this.presence = this.body.presence;
  }
  //</custom-body>
}
